import ROUTES from '@lib/constants/routes';

const getReservedSimilarParams = (flatsList, currentFlat) => {
  const rooms = currentFlat?.rooms === 'studio' ? 0 : currentFlat?.rooms;
  const currentFlatBulk = currentFlat?.bulk.number;
  const similarFlatsSourceParam = 'fromSimilarFlats=true';

  if (!flatsList || flatsList?.length === 0) {
    return `${ROUTES.flats.list}?rooms=${rooms}&sections=${currentFlatBulk}&hideReserved=true&${similarFlatsSourceParam}`;
  }

  // 1. Ищем квартиры с той же комнатностью и в том же корпусе (bulk.id или bulk.number — как у вас используется)
  const similarInBulk = flatsList.filter(
    fl =>
      fl.status !== 'reserve' &&
      fl.id !== currentFlat.id &&
      fl.rooms === currentFlat.rooms &&
      fl.bulk?.number === currentFlatBulk,
  );

  if (similarInBulk.length > 0) {
    return `${ROUTES.flats.list}?rooms=${rooms}&sections=${currentFlatBulk}&hideReserved=true&${similarFlatsSourceParam}`;
  }

  return `${ROUTES.flats.list}?rooms=${rooms}&hideReserved=true`;
};

export default getReservedSimilarParams;
